
export const getBBDDLexon = async (user, idNavision, env, lexonToken) => {
  return new Promise((resolve, reject) => {
    var myHeaders = new Headers();
    myHeaders.append('Accept', 'text/plain');
    myHeaders.append('Authorization', `Bearer ${lexonToken}`);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(
      `${window.API_GATEWAY}/api/v1/lexauth/Lexon/user?entry=${user}&idNavision=${idNavision}&env=${env}`,
      requestOptions
    )
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw `${response.text()}`;
        }
      })
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const getContactsLexon = async (user, idCompany, db, env, lexonToken) => {
  return new Promise((resolve, reject) => {
    var myHeaders = new Headers();
    myHeaders.append('Accept', 'text/plain');
    myHeaders.append('Content-Type', 'application/json-patch+json');
    myHeaders.append('Authorization', `Bearer ${lexonToken}`);
    
    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      //body: raw,
      redirect: 'follow'
    };

    fetch(
      `${window.API_GATEWAY}/api/v1/lexauth/Contacts/${idCompany}/user/${user}/conn/${db}/all?env=${env}`,
      requestOptions
    )
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw `${response.text()}`;
        }
      })
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
};